import request from "../utils/request";

// let headersA = {
//   'token':localStorage.getItem('token')
// }

// 隐私政策
export function policyIndex(params) {
  return request({
    url: "/index/policy",
    method: "get",
    params
  });
}

// ----------------------------------  登录  ----------------------------------
// 申请成为车队
export function loginRegister(data) {
  return request({
    url: "/login/register",
    method: "post",
    data
  });
}
// 获取短信验证码
export function smsSendCode(data) {
  return request({
    url: "/sms/sendCode",
    method: "post",
    data
  });
}
// 手机验证码密码登录
export function loginAccount(data) {
  return request({
    url: "/login/account",
    method: "post",
    data
  });
}
// 忘记密码
export function fleetResetPassword(data) {
  return request({
    url: "/fleet/resetPassword",
    method: "post",
    data
  });
}
// 退出登录
export function scanLogin(data) {
  return request({
    url: "/login/logout",
    method: "post",
    data
  });
}

// ----------------------------------  上传  ----------------------------------
// 上传图片
export function uploadImage(data) {
  return request({
    url: "/upload/image",
    method: "post",
    data
  });
}
// 退出登录
export function uploadVideo(data) {
  return request({
    url: "/upload/video",
    method: "post",
    data
  });
}
// 退出登录
export function uploadIdcard(data) {
  return request({
    url: "/upload/image",
    method: "post",
    data
  });
}
// 退出登录
export function uploadBusinessLicense(data) {
  return request({
    url: "/upload/image",
    method: "post",
    data
  });
}
// 退出登录
export function uploadGeneral_upload(data) {
  return request({
    url: "/upload/image",
    method: "post",
    data
  });
}
// ----------------------------------  基础数据  ----------------------------------
// 获取二维码
export function getQrCode() {
  return request({
    url: "/baseData/getQrCode",
    method: "get",
  });
}
// 订单运输图片实例
export function baseGetOrderBoxTypeImage(params) {
  return request({
    url: "/baseData/getOrderBoxTypeImage",
    method: "get",
    params
  });
}
// 基础配置信息
export function baseConfig() {
  return request({
    url: "/baseData/baseConfig",
    method: "get",
  });
}
// 有效港口数据
export function validPortLists(params) {
  return request({
    url: "/baseData/validPortLists",
    method: "get",
    params
  });
}
// 有效箱型数据
export function validBoxTypeLists(params) {
  return request({
    url: "/baseData/validBoxTypeLists",
    method: "get",
    params
  });
}
// 有效场站
export function validContainerYardLists(params) {
  return request({
    url: "/baseData/validContainerYardLists",
    method: "get",
    params
  });
}
// 找不到场站  添加场站
export function addContainerYard(data) {
  return request({
    url: "/fleet/addContainerYard",
    method: "post",
    data
  });
}
// 发票税点
export function validTaxPointLists() {
  return request({
    url: "/baseData/validTaxPointLists",
    method: "get",
  });
}
// 取消原因
export function validCancelReason() {
  return request({
    url: "/baseData/validCancelReason",
    method: "get",
  });
}
// 司机取消原因说明
export function driverCancelIntro() {
  return request({
    url: "/baseData/driverCancelIntro",
    method: "get",
  });
}
// 追加费用
export function validAppendFeeLists() {
  return request({
    url: "/baseData/validAppendFeeLists",
    method: "get",
  });
}
// 已认证已完善司机列表
export function verifyDriverLists(params) {
  return request({
    url: "/baseData/verifyDriverLists",
    method: "get",
    params
  });
}
// 省份
export function validProvinceLists() {
  return request({
    url: "/baseData/validProvinceLists",
    method: "get",
  });
}
// 城市
export function validCityLists(params) {
  return request({
    url: "/baseData/validCityLists",
    method: "get",
    params
  });
}
// 额外费用
export function validAdditionalBillsLists() {
  return request({
    url: "/baseData/validAdditionalBillsLists",
    method: "get",
  });
}
// 对公转账收款信息
export function getPaymentInformation() {
  return request({
    url: "/baseData/getPaymentInformation",
    method: "get",
  });
}
// 货主取消原因
export function validUserCancelReason() {
  return request({
    url: "/baseData/validUserCancelReason",
    method: "get",
  });
}
// 货主取消原因说明
export function userCancelIntro() {
  return request({
    url: "/baseData/userCancelIntro",
    method: "get",
  });
}
// 信息类型
export function baseInfoType() {
  return request({
    url: "/baseData/baseInfoType",
    method: "get",
  });
}
// 信息间隔时间
export function baseInfoIntervalTime() {
  return request({
    url: "/baseData/baseInfoIntervalTime",
    method: "get",
  });
}
// 信息发布次数
export function baseInfoNumber() {
  return request({
    url: "/baseData/baseInfoNumber",
    method: "get",
  });
}
// 司机数量
export function baseDriverNumber() {
  return request({
    url: "/baseData/baseDriverNumber",
    method: "get",
  });
}
// 车队配置
export function getFleetConfig() {
  return request({
    url: "/baseData/getFleetConfig",
    method: "get",
  });
}
// 船司
export function validShippingCompany(params) {
  return request({
    url: "/baseData/validShippingCompany",
    method: "get",
    params
  });
}

// ----------------------------------  个人信息  ----------------------------------
// 获取个人信息
export function fleetInfo() {
  return request({
    url: "/fleet/info",
    method: "get",
  });
}
// 修改密码
export function changePassword(data) {
  return request({
    url: "/fleet/changePassword",
    method: "post",
    data
  });
}
// 修改手机号
export function bindMobile(data) {
  return request({
    url: "/fleet/bindMobile",
    method: "post",
    data
  });
}
// 设置信息
export function setInfo(data) {
  return request({
    url: "/fleet/setInfo",
    method: "post",
    data
  });
}
// 编辑车队信息
export function setFleetInfo(data) {
  return request({
    url: "/fleet/setFleetInfo",
    method: "post",
    data
  });
}

// ----------------------------------  人员管理  ----------------------------------
// 司机
export function fleetDriverLists(params) {
  return request({
    url: "/fleetDriver/lists",
    method: "get",
    params
  });
}
// 司机
export function fleetDriverAdd(data) {
  return request({
    url: "/fleetDriver/add",
    method: "post",
    data
  });
}
// 司机
export function fleetDriverRemove(data) {
  return request({
    url: "/fleetDriver/remove",
    method: "post",
    data
  });
}
// 司机
export function fleetDriverDetail(params) {
  return request({
    url: "/fleetDriver/detail",
    method: "get",
    params
  });
}

// 调度员
export function fleetMemberLists(params) {
  return request({
    url: "/fleetMember/lists",
    method: "get",
    params
  });
}
// 调度员
export function fleetMemberDetail(params) {
  return request({
    url: "/fleetMember/detail",
    method: "get",
    params
  });
}
// 调度员
export function fleetMemberAdd(data) {
  return request({
    url: "/fleetMember/add",
    method: "post",
    data
  });
}
// 调度员
export function fleetMemberEdit(data) {
  return request({
    url: "/fleetMember/edit",
    method: "post",
    data
  });
}
// 调度员
export function fleetMemberDelete(data) {
  return request({
    url: "/fleetMember/delete",
    method: "post",
    data
  });
}
// 调度员
export function fleetMemberResetPassword(data) {
  return request({
    url: "/fleetMember/resetPassword",
    method: "post",
    data
  });
}

// ----------------------------------  接单大厅  ----------------------------------
// 接单大厅
export function orderHallLists(params) {
  return request({
    url: "/order/orderHallLists",
    method: "get",
    params
  });
}
// 子订单列表
export function orderHallSubOrderLists(params) {
  return request({
    url: "/order/orderHallSubOrderLists",
    method: "get",
    params
  });
}
// 子订单详情
export function orderHallSubOrderDetail(params) {
  return request({
    url: "/order/orderHallSubOrderDetail",
    method: "get",
    params
  });
}
// 申请加价记录
export function markUpLists(params) {
  return request({
    url: "/order/markUpLists",
    method: "get",
    params
  });
}
// 立即抢单
export function orderGrabbing(data) {
  return request({
    url: "/order/orderGrabbing",
    method: "post",
    data
  });
}
// 申请加价
export function applyMarkUp(data) {
  return request({
    url: "/order/applyMarkUp",
    method: "post",
    data
  });
}
// 加价后拒绝接单
export function rejectTakeOrders(data) {
  return request({
    url: "/order/rejectTakeOrders",
    method: "post",
    data
  });
}

// ----------------------------------  承运订单  ----------------------------------
// 接单列表
export function myOrderList(params) {
  return request({
    url: "/order/myOrderList",
    method: "get",
    params
  });
}
// 子订单列表
export function myOrderSubOrderLists(params) {
  return request({
    url: "/order/myOrderSubOrderLists",
    method: "get",
    params
  });
}
// 订单详情
export function myOrderDetail(params) {
  return request({
    url: "/order/myOrderDetail",
    method: "get",
    params
  });
}
// 分配
export function allocateOrder(data) {
  return request({
    url: "/order/allocateOrder",
    method: "post",
    data
  });
}
// 取消分配
export function cancelAllocateOrder(data) {
  return request({
    url: "/order/cancelAllocateOrder",
    method: "post",
    data
  });
}
// 转单
export function transferOrder(data) {
  return request({
    url: "/order/transferOrder",
    method: "post",
    data
  });
}
// 取消转单
export function cancelTransferOrder(data) {
  return request({
    url: "/order/cancelTransferOrder",
    method: "post",
    data
  });
}
// 取消总订单
export function cancelOrder(data) {
  return request({
    url: "/order/cancelOrder",
    method: "post",
    data
  });
}
// 取消子订单
export function cancelOrderBoxType(data) {
  return request({
    url: "/order/cancelOrderBoxType",
    method: "post",
    data
  });
}
// 订单箱型图片
export function imageLists(params) {
  return request({
    url: "/order/imageLists",
    method: "get",
    params
  });
}
// 提交运输图片
export function submitImage(data) {
  return request({
    url: "/order/submitImage",
    method: "post",
    data
  });
}
// 删除运输图片
export function deleteImage(params) {
  return request({
    url: "/order/deleteImage",
    method: "post",
    params
  });
}
// 修改子订单装卸货时间
export function checkSetLoadingTime(data) {
  return request({
    url: "/order/checkSetLoadingTime",
    method: "post",
    data
  });
}
// 子订单添加额外费用
export function addAdditionalBills(data) {
  return request({
    url: "/order/addAdditionalBills",
    method: "post",
    data
  });
}
// 子订单额外费用列表
export function getAdditionalBills(params) {
  return request({
    url: "/order/getAdditionalBills",
    method: "get",
    params
  });
}
// 编辑额外费用
export function editAdditionalBills(data) {
  return request({
    url: "/order/editAdditionalBills",
    method: "post",
    data
  });
}
// 删除额外费用
export function deleteAdditionalBills(data) {
  return request({
    url: "/order/deleteAdditionalBills",
    method: "post",
    data
  });
}
// 我已送达
export function boxTypeDelivered(data) {
  return request({
    url: "/order/boxTypeDelivered",
    method: "post",
    data
  });
}
// 获取开票信息
export function getOrderInvoicing(params) {
  return request({
    url: "/order/getOrderInvoicing",
    method: "get",
    params
  });
}
// 上传发票
export function uploadInvoiceImage(data) {
  return request({
    url: "/order/uploadInvoiceImage",
    method: "post",
    data
  });
}
// 无法开票
export function unableProvideInvoice(data) {
  return request({
    url: "/order/unableProvideInvoice",
    method: "post",
    data
  });
}
// 订单箱型图片
export function imageStatus(params) {
  return request({
    url: "/order/imageStatus",
    method: "get",
    params
  });
}



// ----------------------------------  留言通知  ----------------------------------
// 系统消息
export function systemListsXX(params) {
  return request({
    url: "/noticeRecord/systemLists",
    method: "get",
    params
  });
}

// 系统消息详情
export function systemDetailXX(params) {
  return request({
    url: "/noticeRecord/systemDetail",
    method: "get",
    params
  });
}

// 未读数量
export function unReadNumXX(params) {
  return request({
    url: "/noticeRecord/unReadNum",
    method: "get",
    params
  });
}

// 清除未读
export function clearUnreadXX() {
  return request({
    url: "/noticeRecord/clearUnread",
    method: "post",
  });
}

// 订单通知
export function ordersListsXX(params) {
  return request({
    url: "/noticeRecord/ordersLists",
    method: "get",
    params
  });
}

// 订单通知详情
export function ordersDetailXX(params) {
  return request({
    url: "/noticeRecord/ordersDetail",
    method: "get",
    params
  });
}

// 添加留言
export function addMessageRecord(data) {
  return request({
    url: "/noticeRecord/addMessageRecord",
    method: "post",
    data
  });
}

// 留言记录
export function myMessageRecordLists(params) {
  return request({
    url: "/noticeRecord/myMessageRecordLists",
    method: "get",
    params
  });
}

// 留言记录回复列表
export function messageRecordReplyLists(params) {
  return request({
    url: "/noticeRecord/messageRecordReplyLists",
    method: "get",
    params
  });
}



// ----------------------------------  钱包  ----------------------------------
// 我的钱包
export function myWalletInfo() {
  return request({
    url: "/fleet/myWalletInfo",
    method: "get",
  });
}

// 提交充值信息
export function submitRecharge(data) {
  return request({
    url: "/fleet/submitRecharge",
    method: "post",
    data
  });
}

// 充值记录
export function balanceRechargeLists(params) {
  return request({
    url: "/fleet/balanceRechargeLists",
    method: "get",
    params
  });
}

// 充值记录详情
export function balanceRechargeDetails(params) {
  return request({
    url: "/fleet/balanceRechargeDetails",
    method: "get",
    params
  });
}

// 申请提现
export function applyWithdraw(data) {
  return request({
    url: "/fleet/applyWithdraw",
    method: "post",
    data
  });
}

// 余额提现记录
export function balanceWithdrawLists(params) {
  return request({
    url: "/fleet/balanceWithdrawLists",
    method: "get",
    params
  });
}

// 余额提现详情
export function balanceWithdrawDetails(params) {
  return request({
    url: "/fleet/balanceWithdrawDetails",
    method: "get",
    params
  });
}

// 订单流水
export function orderFlowLists(params) {
  return request({
    url: "/fleet/orderFlowLists",
    method: "get",
    params
  });
}

// 订单流水详情
export function orderFlowDetails(params) {
  return request({
    url: "/fleet/orderFlowDetails",
    method: "get",
    params
  });
}
// 收入记录
export function orderIncomeLists(params) {
  return request({
    url: "/fleet/orderIncomeLists",
    method: "get",
    params
  });
}

// 收入记录详情
export function orderIncomeDetails(params) {
  return request({
    url: "/fleet/orderIncomeDetails",
    method: "get",
    params
  });
}




